export { default as Card } from './base'
